// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3AFu8","alert":"SettungsInbox_alert__2dT8L"};